import { render, staticRenderFns } from "./Section08.vue?vue&type=template&id=24c6a4f7&"
import script from "./Section08.vue?vue&type=script&lang=js&"
export * from "./Section08.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports